export default __webpack_public_path__ + "static/media/gallery-wip-control-box_02.01e8a13e.jpg";